import { render, staticRenderFns } from "./AliyunCaptchaGuard.vue?vue&type=template&id=4bcbbc31&scoped=true"
import script from "./AliyunCaptchaGuard.vue?vue&type=script&lang=js"
export * from "./AliyunCaptchaGuard.vue?vue&type=script&lang=js"
import style0 from "./AliyunCaptchaGuard.vue?vue&type=style&index=0&id=4bcbbc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbbc31",
  null
  
)

export default component.exports